'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _userPresence = require('./presence/userPresence');
var _userPresence2 = _interopRequireDefault(_userPresence);
var _errorWatcher = require('./connection/errorWatcher');
var _errorWatcher2 = _interopRequireDefault(_errorWatcher);
var _connectionManager = require('./connection/connectionManager');
var _connectionManager2 = _interopRequireDefault(_connectionManager);
var _chatManager = require('./chat/chatManager');
var _chatManager2 = _interopRequireDefault(_chatManager);
var _chatHandler = require('./chat/chatHandler');
var _chatHandler2 = _interopRequireDefault(_chatHandler);
var _messenger = require('./message/messenger');
var _messenger2 = _interopRequireDefault(_messenger);
var _messageHandler = require('./message/messageHandler');
var _messageHandler2 = _interopRequireDefault(_messageHandler);
var _validator = require('./validator/validator');
var _validator2 = _interopRequireDefault(_validator);
var _lastTimestampHandler = require('./infra/lastTimestampHandler');
var _lastTimestampHandler2 = _interopRequireDefault(_lastTimestampHandler);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var modules = [_lastTimestampHandler2.default, _errorWatcher2.default, _connectionManager2.default, _userPresence2.default, _chatManager2.default, _chatHandler2.default, _messenger2.default, _messageHandler2.default, _validator2.default];
exports.default = modules;